import { Component } from 'react';
import { connect } from 'react-redux';
import { t } from '../../../helpers/translation_helper';
import { toggleAIGenerationModal } from '../../../redux/slices/AIGenerationModalSlice';

class AIGenerationButton extends Component {

  state = {
    dynamicAIPrompt: this.props.dynamicAIPrompt || ''
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dynamicAIPrompt !== this.props.dynamicAIPrompt) {
      this.setState({ dynamicAIPrompt: this.props.dynamicAIPrompt });
    }
  }

  render() {
    return (
      <button
        disabled={this.props.disabled}
        className="me-2"
        style={{
          color: '#fff',
          background: 'linear-gradient(90deg, #00c4cc 13%,#5a32fa 52%, #7d2ae8 70%, #FF00C6 100%)',
          border: 'none',
          display: 'flex',
          alignItems: 'center',
          paddingInline: 10,
          borderRadius: 7,
          opacity: this.props.disabled ? 0.5 : 1,
          ...this.props.style
        }} onClick={() => {
          console.log('dynamicAIPrompt:', this.state.dynamicAIPrompt);
          this.props.toggleAIGenerationModal({
            dynamicAIPrompt: this.state.dynamicAIPrompt
          });
        }}>
        <small style={{
          backgroundColor: '#D23341',
          color: '#fff',
          padding: '2px 5px',
          borderRadius: '5px',
          fontSize: 10,
          fontWeight: '600',
          marginRight: 5,
        }}>{t('NEW')}</small>
        <svg style={{ marginRight: 1 }} width="25" height="25" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
          <path
            fill="#fff"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.568 16.49c-1.808-.595-3.284-1.453-4.46-2.672-1.13-1.171-1.917-2.61-2.479-4.31-.575 1.75-1.39 3.204-2.548 4.375-1.176 1.19-2.639 2.019-4.395 2.599 1.802.588 3.275 1.435 4.448 2.642 1.139 1.172 1.928 2.615 2.49 4.329.576-1.75 1.391-3.202 2.548-4.37 1.177-1.19 2.64-2.015 4.396-2.593Zm-6.306 9.48a.657.657 0 0 1-.636.517.657.657 0 0 1-.643-.55c-1.067-5.2-3.357-7.717-8.69-8.784a.667.667 0 0 1 0-1.333c4.785-.982 7.228-3.12 8.418-7.612l.002-.01c.102-.385.195-.789.28-1.21a.657.657 0 0 1 .776-.486.663.663 0 0 1 .489.48c1.066 5.2 3.368 7.771 8.701 8.838a.667.667 0 0 1 0 1.333c-5.2 1.067-7.63 3.484-8.697 8.818Zm9.892-17.553c.11-.07.224-.132.343-.188a3.62 3.62 0 0 1 .925-.292.2.2 0 0 0 .2-.203c0-.113-.083-.187-.194-.208l-.031-.008a2.032 2.032 0 0 1-.053-.013 4.83 4.83 0 0 1-.829-.297 3.963 3.963 0 0 1-.363-.194 3.237 3.237 0 0 1-1.27-1.39 3.618 3.618 0 0 1-.273-.825l-.005-.026a4.401 4.401 0 0 1-.014-.075.204.204 0 0 0-.204-.204v.004c-.112 0-.187.083-.208.194l-.007.03a1.733 1.733 0 0 1-.014.054 4.828 4.828 0 0 1-.295.827c-.06.128-.125.25-.195.365a3.237 3.237 0 0 1-1.391 1.27 3.621 3.621 0 0 1-.926.292.204.204 0 0 0-.204.204h.005c0 .112.083.187.193.208l.031.007.043.01.01.003c.3.079.575.178.828.296.127.06.249.125.365.195a3.237 3.237 0 0 1 1.27 1.391 3.618 3.618 0 0 1 .272.824l.005.026.015.076a.204.204 0 0 0 .203.203v-.004c.113 0 .187-.083.208-.193l.008-.031a2.254 2.254 0 0 1 .013-.054c.078-.298.177-.574.296-.827.06-.127.124-.249.194-.365a3.239 3.239 0 0 1 1.05-1.082ZM9.53 25.917c.076-.047.155-.089.239-.128a3.245 3.245 0 0 1 .79-.254.29.29 0 1 0 0-.58 6.041 6.041 0 0 1-.766-.288 3.787 3.787 0 0 1-.26-.135 2.605 2.605 0 0 1-1.097-1.163 3.246 3.246 0 0 1-.253-.79.29.29 0 0 0-.581 0 5.22 5.22 0 0 1-.288.766 3.76 3.76 0 0 1-.135.258 2.604 2.604 0 0 1-1.163 1.098 3.239 3.239 0 0 1-.79.253.29.29 0 0 0 0 .581l.124.039c.231.074.445.156.641.25.09.042.177.087.26.134a2.604 2.604 0 0 1 1.097 1.163 3.242 3.242 0 0 1 .254.79.29.29 0 0 0 .58 0l.04-.123c.073-.232.156-.446.249-.642.042-.09.087-.177.135-.26.236-.412.534-.734.924-.97ZM11.115 8.47c-1.254.472-2.1 1.207-2.586 2.454a5.944 5.944 0 0 0-.227.722 8.187 8.187 0 0 0-.168.888.287.287 0 0 1-.266.266.287.287 0 0 1-.267-.266 9.144 9.144 0 0 0-.168-.888 5.944 5.944 0 0 0-.227-.722C6.72 9.677 5.874 8.942 4.62 8.47a8.384 8.384 0 0 0-.813-.257 12.674 12.674 0 0 0-.873-.195.287.287 0 0 1-.267-.267c0-.133.134-.267.267-.267l.104-.01c.284-.027.552-.064.804-.111.29-.055.561-.123.812-.205C5.86 6.764 6.62 6.044 7.089 4.934a5.84 5.84 0 0 0 .122-.314c.088-.247.164-.512.23-.796a9.878 9.878 0 0 0 .16-.89c0-.134.133-.267.267-.267.133 0 .266.133.266.267a10.962 10.962 0 0 0 .16.89c.066.284.142.549.23.796.038.108.079.212.122.314.468 1.11 1.228 1.83 2.435 2.224.251.082.521.15.812.205a9.128 9.128 0 0 0 .908.121c.133 0 .267.134.267.267a.287.287 0 0 1-.267.267 13.245 13.245 0 0 0-.873.195c-.288.076-.56.161-.813.257Z"
          />
        </svg>
        {t('Educore AI')}
      </button>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = () => ({
  toggleAIGenerationModal,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps()
)(AIGenerationButton);